import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { S, SERIF, SANS, IMG, Eyebrow, Reveal, H2, Section, scrollToId } from "./slUi";

const AREAS = [
  { k: "create", img: IMG.create, title: "Create", line: "Tell Soulumo what you want to work on.",
    more: "Peace. Confidence. Self-belief. Relationships. Performance. Abundance. Sleep. Letting go. Or something completely personal. Adelaida helps turn what matters to you into language that feels right.", go: "sl-personal" },
  { k: "installations", img: IMG.listen, title: "Your installations", line: "Personal audio, built around you.",
    more: "Create audio experiences built around the thoughts, beliefs and inner dialogue you want to strengthen. Choose the mood and duration. Listen when it suits you.", go: "sl-layers" },
  { k: "night", img: IMG.night, title: "Night", line: "Reset → Relax → Receive.",
    more: "Not another playlist. A three-hour journey that lets the day go, grows quieter and more spacious, then lets your own words appear gently within the soundscape.", go: "sl-night" },
  { k: "together", img: IMG.togetherCard, title: "21 Days Together", line: "One intention. 21 days. Together.",
    more: "Invite the people you care about to follow the same 21-day rhythm with you. A partner, a family, friends, a team, a community. Optional, simple and quietly meaningful.", go: "sl-together" },
  { k: "gift", img: IMG.gift, title: "Gift", line: "Send someone a little more peace.",
    more: "Create or choose something meaningful and send it as a Soulumo experience. Then, if you'd like: would you like to do the gift together?", go: "sl-together" },
  { k: "session", img: IMG.coach, title: "After your session", line: "Take the work with you.",
    more: "Your coach can turn the important language from your session into a personal Soulumo experience, in your own voice, so you keep returning to it long after the session has finished.", go: "sl-coaches" },
];

const Card = ({ a, on, onTap }) => (
  <button type="button" onClick={onTap} data-testid={`sl-area-${a.k}`}
    className="group relative block w-full aspect-[4/5] sm:aspect-[3/4] overflow-hidden rounded-2xl text-left transition-transform duration-500 hover:-translate-y-1"
    style={{ outline: on ? `2px solid ${S.gold}` : "none", outlineOffset: 3 }}>
    <img src={a.img} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
    <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(7,13,29,0) 40%, rgba(7,13,29,0.78) 100%)" }} />
    <div className="absolute inset-x-0 bottom-0 p-4 sm:p-5" style={{ color: S.cream }}>
      <p className="text-xl sm:text-2xl" style={{ fontFamily: SERIF }}>{a.title}</p>
      <p className="mt-1 text-xs sm:text-sm" style={{ fontFamily: SANS, color: S.dim }}>{a.line}</p>
    </div>
  </button>
);

export const Areas = () => {
  const [sel, setSel] = useState("create");
  const a = AREAS.find((x) => x.k === sel);
  return (
    <Section tone="light" id="sl-areas" testId="sl-areas" className="py-24 sm:py-32">
      <div className="max-w-6xl mx-auto">
        <Reveal><Eyebrow>Inside Soulumo</Eyebrow></Reveal>
        <Reveal delay={0.05}><H2 className="mt-4 max-w-3xl">Everything begins with <span className="" style={{ color: S.bronze }}>what you want to feel.</span></H2></Reveal>
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5">
          {AREAS.map((x, i) => <Reveal key={x.k} delay={0.06 * i}><Card a={x} on={sel === x.k} onTap={() => setSel(x.k)} /></Reveal>)}
        </div>
        <>
          <motion.div key={a.k} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }} transition={{ duration: 0.45 }}
            className="mt-8 rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row sm:items-end gap-5 justify-between" style={{ background: S.sand }} data-testid="sl-area-detail">
            <div className="max-w-2xl">
              <p className="text-3xl" style={{ fontFamily: SERIF }}>{a.title}</p>
              <p className="mt-3 text-base sm:text-lg leading-relaxed" style={{ fontFamily: SANS, color: S.inkDim }}>{a.more}</p>
            </div>
            <button type="button" onClick={() => scrollToId(a.go)} data-testid="sl-area-detail-go" className="shrink-0 inline-flex items-center gap-2 text-[0.66rem] uppercase tracking-[0.26em]" style={{ fontFamily: SANS, color: S.bronze }}>
              See how it works <ArrowDown size={13} />
            </button>
          </motion.div>
        </>
      </div>
    </Section>
  );
};
